import { hungerMoment } from "@/moment";
import moment from "moment";
import { useState } from "react";

const usePeriodSetter = () => {
  const [startAt, setStartAt] = useState<moment.Moment>(() =>
    hungerMoment().startOf("month")
  );
  const [endAt, setEndAt] = useState<moment.Moment>(() => hungerMoment());

  return {
    startAt,
    endAt,
    setStartAt,
    setEndAt,
  };
};

export default usePeriodSetter;
